// Which board the Rig Preview panel opens on.
//
// ARKit-52 reaches barely a third of the controls a splat bundle's decoders were
// trained on, so for those characters it is the REDUCED view — landing there
// first makes the bundle's own rig look like an extra mode rather than the rig.
// A GLB character has no bundle board at all and stays on ARKit.
//
// The timing is why this is a rule and not one ternary: the bundle publishes
// its control space ASYNCHRONOUSLY (the pipeline builds its branches after the
// panel mounts), so the choice has to be revisited on arrival — but only while
// the user has not made one, or reopening a character would yank them out of the
// board they picked.

export const ARKIT = 'arkit'
export const BUNDLE = 'raw'

/** The mode to mount with, given whether a bundle board is already published. */
export function initialRigPanelMode(hasBoard) {
  return hasBoard ? BUNDLE : ARKIT
}

/**
 * The mode after the board source changes.
 * @param {string}  current   the mode now
 * @param {boolean} hasBoard  a bundle has published a control space
 * @param {boolean} userChose the user has clicked the mode switch at least once
 */
export function nextRigPanelMode(current, hasBoard, userChose) {
  if (userChose) return current            // their choice outranks any arrival
  return hasBoard ? BUNDLE : current       // a board appearing promotes; losing one does NOT
}
